import { Stack } from 'react-bootstrap';
import TimeAndWeatherWidget from '../components/shared/TimeAndWeatherWidget';

export function Home() {
    return (
        <div className="home-page" style={{ height: 'calc(100% )' }}>
            <Stack style={{ height: '100%' }}>
                <Stack>
                    <div className="ms-auto">
                        <TimeAndWeatherWidget
                            fontColor="rgba(0,0,0,0.9)"
                            fontSize="1em"
                            margin="1.5em"
                        />
                    </div>
                </Stack>
            </Stack>
        </div>
    );
}
